export default __webpack_public_path__ + "1db568065da36b10c134453f42f33603.png";